// extracted by mini-css-extract-plugin
module.exports = {"repo-region":"_1evYqtvzUp","title-section":"_3obRK0jqBD","table-section":"h_HXrQWNJH","add-btn":"fSsFkRVAeI","operation":"_1Tr-L1Lc2B"};